import ApiUtils from "../ApiUtils";

export default class ApiClassTopicService {

    async addClassTopic(data) {
        return await ApiUtils.callApi('class/topic/add', 'post', data);
    }

    async getAClassTopic(topicId) {
        return await ApiUtils.callApi(`common/class/get-topic/${topicId}`, 'get');
    }

    async updateClassTopic(data){
        return await ApiUtils.callApi(`common/class/update-topic`, 'put', data);
    }

    async addClassTopicCategory(data) {
        return await ApiUtils.callApi('class/topic/category/add', 'post', data);
    }

    async getAClassTopicCategory(categoryId) {
        return await ApiUtils.callApi(`class/topic/category/${categoryId}`, 'get');
    }

    async updateClassTopicCategory(data) {
        return await ApiUtils.callApi('class/topic/category/edit', 'post', data);
    }

    async topicListsByCategory(categoryId) {
        return await ApiUtils.callApi(`class/topic/list${categoryId ? '/'+categoryId : ''}`, 'get');
    }

    async addQuestion(topicId, questionData) {
        return await ApiUtils.callApi(`topic/exam/add`, 'post', questionData);
    }

    async updateQuestion(topicId, questionData) {
        return await ApiUtils.callApi(`topic/exam/question`, 'post', questionData);
    }

    async getTopicQuestions(topicId) {
        return await ApiUtils.callApi(`topic/exam/${topicId}`, 'get');
    }

    async deleteExamByTopicId(topicId) {
        return await ApiUtils.callApi(`topic/exam/delete/${topicId}`, 'delete');
    }
}

